import { useIntl } from 'react-intl';
import { MetabaseError } from './MetabaseError';

const MetabaseCollectionsError = () => {
  const intl = useIntl();

  return (
    <MetabaseError
      title={intl.formatMessage({
        id: 'containers.errorPage.metabase-collections-error.title',
      })}
      description={intl.formatMessage({
        id: 'containers.errorPage.metabase-collections-error.text',
      })}
    />
  );
};

export { MetabaseCollectionsError };
